import { render } from "./AddPayment.vue?vue&type=template&id=57dea92f&scoped=true"
import script from "./AddPayment.vue?vue&type=script&lang=js"
export * from "./AddPayment.vue?vue&type=script&lang=js"

import "./AddPayment.vue?vue&type=style&index=0&id=57dea92f&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57dea92f"]])

export default __exports__